function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#0052b4",
  d: "M0 85.331h512v341.337H0z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M329.244 264.191l30.641-11.906-30.641-11.906-16.829-6.54-27.343-10.625-10.625-27.343c17.916 5.872 32.095 20.05 37.967 37.967l16.829 6.54c-5.087-31.398-29.94-56.251-61.336-61.338L256 148.4l-11.906 30.641c-31.397 5.087-56.251 29.94-61.336 61.338l-30.641 11.906 30.641 11.906c5.085 31.397 29.94 56.251 61.336 61.336L256 356.168l11.906-30.641c31.398-5.085 56.251-29.939 61.338-61.336zm-55.639-29.511L256 252.285h62.91l-45.305 17.605L256 252.285v62.911l-17.605-45.305L256 252.285h-62.91l45.304-17.604L256 252.285v-62.91l17.605 45.305zm-36.051-38.809l-10.625 27.343-27.342 10.625c5.872-17.918 20.05-32.094 37.967-37.968zm-37.968 74.86l27.342 10.625 10.625 27.342c-17.916-5.873-32.093-20.051-37.967-37.967zm74.86 37.966l10.625-27.342 27.342-10.625c-5.873 17.917-20.051 32.095-37.967 37.967z",
  fill: "#f0f0f0"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M318.91 252.285H256l17.605 17.605zm-125.82 0H256l-17.605-17.605zm62.91 62.91v-62.91l-17.605 17.605zm0-62.91l17.605-17.605L256 189.374z",
  fill: "#0052b4"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M248.576 103.875h14.84v29.682h-14.84zM107.598 244.864h29.682v14.84h-29.682zm140.978 126.141h14.84v29.682h-14.84zm126.152-126.141h29.682v14.84h-29.682z",
  fill: "#f0f0f0"
});

const SvgOtan = (_ref) => {
  let svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgOtan, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/otan.7805ae38.svg";
export { ForwardRef as ReactComponent };